import React from 'react';
import classNames from 'classnames';
import styles from './ToggleButton.module.scss';

interface ToggleProps {
	checked: boolean;
	onChange: (checked: boolean) => void;
	disabled?: boolean;
	size?: 'small' | 'default';
}

const ToggleButton: React.FC<ToggleProps> = ({
	checked,
	onChange,
	disabled = false,
	size = 'default'
}) => {
	return (
		<div
			className={classNames(styles.track, {
				[styles['track--checked']]: checked,
				[styles['track--disabled']]: disabled,
				[styles['track--small']]: size === 'small'
			})}
			onClick={() => !disabled && onChange(!checked)}
		>
			<div className={styles.thumb} />
		</div>
	);
};

export default ToggleButton;
